import { render } from "./EventsCount.vue?vue&type=template&id=b301200e&scoped=true"
import script from "./EventsCount.vue?vue&type=script&lang=js"
export * from "./EventsCount.vue?vue&type=script&lang=js"

import "./EventsCount.vue?vue&type=style&index=0&id=b301200e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b301200e"]])

export default __exports__